import "./TabsList.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { classNames } from "../../../utils/helpers/classNames";

export const TabsList = ({ tabs, activeTab, setActiveTab }) => (
    <Swiper
      className="tabs-list"
      spaceBetween={32}
      slidesPerView="auto"
      wrapperTag="ul"
      watchOverflow
    >
      {tabs.map(({ value, label }) => (
        <SwiperSlide
          style={{ width: "auto", height: "auto" }}
          key={value}
        >
          <li
            className={classNames(
              "tabs-list__item",
              { "tabs-list__item--active": activeTab === value }
            )}
            key={value}
            onClick={() => setActiveTab(value)}
          >
            {label}
          </li>
        </SwiperSlide>
      ))}
    </Swiper>
  );
